<!--
 * @Descripttion: 
 * @Version: 1.0.0
 * @Author: Li Yong
 * @Date: 2022-06-06 19:51:31
 * @LastEditors: 吴作杰 15727841808@163.com
 * @LastEditTime: 2023-10-08 15:45:30
-->
<template>
	<div>
		<el-dialog class="success" :visible="successVisible" :show-close="false" width="392px" :close-on-click-modal="false">
			<div slot="title"></div>
			<div class="flex-column flex-align-center">
				<i class="el-icon-success yx-color-success success"></i>
				<p class="fz-18 mt-26 mb-30">{{ successContent }}</p>
				<div class="mt-10 mb-10">
					<el-button type="primary" @click="ok">我知道了</el-button>
				</div>
			</div>
		</el-dialog>
		<el-dialog title="提示" :visible="failVisible" width="392px" :close-on-click-modal="false">
			<div class="fz-14 mt-8 flex flex-align-center">
				<img src="@/assets/public/warning-org.png" class="warn-img" alt="" />
				<div class="ml-6">
					校验到您授权异常，请
					<span v-if="$isDy()">根据下方教程提示关闭授权后，再重新授权或</span>
					<el-tooltip placement="top">
						<img slot="content" :src="baseInfo.partner_auth_code" alt="" width="160" height="160" />
						<a href="javascript:;" class="fz-14 ml-6 mr-6 yx-color-primary">联系客服</a>
					</el-tooltip>
					<span v-if="!$isDy()">协助您解决</span>
				</div>
			</div>
			<div slot="footer" class="dialog-footer flex flex-just-between">
				<div class="ml-18 fz-14">
					<a v-if="$isDy()" target="_blank" href="https://yangxuan.feishu.cn/docs/doccnry7mJfGmsm6O5Qk6XNnXbd" class="yx-color-primary">
						查看授权异常处理
					</a>
				</div>
				<el-button @click="close">关闭</el-button>
			</div>
		</el-dialog>
	</div>
</template>
<script>
import mixin from '@/mixins';
import authMixin from './mixin';
import { AUTH_RESULT_STATUS_REPEAT_AUTHED, AUTH_RESULT_STATUS_HAS_AUTHED } from '@/utils/dataMap';
import { mapGetters } from 'vuex';
export default {
	mixins: [mixin, authMixin],
	data() {
		return {
			successVisible: false,
			failVisible: false,
			platformId: '',
		};
	},
	computed: {
		...mapGetters(['isTrialAccount']),
		successContent() {
			return this.isTrialAccount
				? '账号授权成功，当前为试用账号，首次同步商品时间较长且订单仅同步最近7天的订单，请联系客服升级至正式版'
				: '账号授权成功，首次同步商品时间较长，请耐心等待。';
		},
	},
	methods: {
		show(isSuccess, platformId, link, statusId) {
			this.platformId = platformId;
			if (isSuccess) return (this.successVisible = true);
			// 同一个租户授权同店铺/不同租户授权同店铺
			if ([AUTH_RESULT_STATUS_REPEAT_AUTHED, AUTH_RESULT_STATUS_HAS_AUTHED].includes(statusId)) {
				setTimeout(() => {
					const msg =
						statusId === AUTH_RESULT_STATUS_REPEAT_AUTHED ? '该店铺已授权，无需重新授权' : '授权失败，该店铺已授权给其它公司，如有疑问请联系客户';
					this.$message.error(msg);
					this.$router.push({ query: {} });
				}, 1000);
				return;
			}
			this.checkAuthorize(link);
		},
		ok() {
			this.successVisible = false;
			this.$router.push({ query: {} });
		},
		async checkAuthorize(link) {
			if (link) return (this.link = link), (this.failVisible = true);
			const { data } = await this.getAuthLink(this.platformId);
			this.link = data.institution_url;
			this.failVisible = true;
		},
		close() {
			this.failVisible = false;
			this.$router.push({ query: {} });
		},
		again() {
			const { link, openBlankWindow } = this;
			openBlankWindow(link);
		},
	},
};
</script>
<style lang="less" scoped>
.success {
	/deep/ .el-dialog__header {
		border: 1px solid transparent;
	}
	.success {
		font-size: 52px;
	}
}
.warn-img {
	width: 16px;
	height: 16px;
}
</style>
